<template>
  <div class="auth-input-wrapper">
    <input :class="{ error: !login.isValid || usernameIsAlreadyTaken,
          valid: (login.isValid && login.length > 0) }"
      @input="validateWithDebounce"
      @blur="validate"
      v-model="value"
      type="text"
      id="login"
      required
    >
    <label for="login">Login</label>
    <p class="error" v-if="usernameIsAlreadyTaken">Podany login jest zajęty!</p>
    <p class="error" v-else-if="login.isTooShort">Treść pola jest zbyt krótka!</p>
    <p class="error" v-else-if="login.isTooLong">Treść pola jest zbyt długa!</p>
    <p class="error"
      v-if="!login.isAlphanumeric
      && !login.isTooShort
      && !login.isTooLong"
    >Niepoprawny login!</p>
  </div>
</template>

<script>
import { validateLogin, debounce, debounceOffset } from '../authValidation';

export default {
  name: 'LoginAuthInput',
  data() {
    return {
      login: {
        isValid: true,
        isTooShort: false,
        isTooLong: false,
        isAlphanumeric: true,
        length: 0
      }
    };
  },
  computed: {
    value: {
      get() {
        return this.$store.getters.registrationLogin;
      },
      set(value) {
        this.$store.commit('updateRegistrationLogin', value);
      }
    },
    usernameIsAlreadyTaken() {
      return this.$store.getters.usernameIsAlreadyTaken;
    }
  },
  methods: {
    validateWithDebounce(e) {
      this.$store.dispatch('clearAllAuthErrors');
      debounce(() => {
        this.validate(e);
      }, debounceOffset);
    },
    validate(e) {
      validateLogin(e, this.login);
      this.$store.commit('updateIsRegistrationLoginValid', this.login.isValid);
    }
  }
};
</script>
